import { useEffect, useState } from "react"
import List from "../../components/List"
import RolesHeader from "../../components/Roles-header"
import WithSidebar from "../../layouts/WithSidebar"
import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import { useSnackbar } from "notistack"
import context from '../../scripts/context'

const Roles = () => {
    const { enqueueSnackbar } = useSnackbar()
    const columns = [
        {name: 'ID'},
        {name: 'Role name'},
        {name: 'Description'},
        {name: 'Action'}
    ]

    const [data, setData] = useState()
    
    const roleInputFilter = context.getRoleInputFilter()
    const [totalCounts, setTotalCounts] = useState(roleInputFilter.totalCounts);
    const [page, setPage] = useState(roleInputFilter.page)
    const [rowsPerPage, setRowsPerPage] = useState(roleInputFilter.rowsPerPage)

    const makeParams = (inputs)=>{
        let params = ''
        let count = 0
        Object.keys(inputs).forEach( (e) => {
            if(inputs[e].type !== 'select' && inputs[e].value ) {
                if(inputs[e].isDate) {
                    params+= `&${inputs[e].name}=${inputs[e].value.utc(true).toISOString()}`
                    count ++
                }else{
                    params += `&${inputs[e].name}=${inputs[e].value}`
                    count ++
                }
            }
            if(inputs[e].type === 'select' && inputs[e].value && inputs[e].name === 'status') {
                params += `&${inputs[e].name}=${inputs[e].selected}`
                count ++
            }
            if(inputs[e].type === 'select' && inputs[e].value && inputs[e].name === 'privileges') {
                for(const p of inputs[e].value){

                    params += `&${inputs[e].name}=${p.id}`
                    count ++
                }
            }
        })
        // setFilterNumber(count)
        return {params, count}
    }

    const firstParams = makeParams(roleInputFilter)
    const [params, setParams] = useState(firstParams.params)
    const [filterNumber, setFilterNumber] = useState(firstParams.count)






    const getRoles = async (page) => {
        const res = await ajax({
            method: 'GET',
            url: `${utils.urls.roleList}?size=${context.getRoleInputFilter().rowsPerPage}&page=${page}${params}`,
            snackbar: enqueueSnackbar,
            hasToken: true
        })

        if(!res) return

        setData(res.data.content)
        context.setRoleInputFilter({
            ...context.getRoleInputFilter(),
            totalCounts:res.data.totalElements
        })
        setTotalCounts(res.data.totalElements)

    }

    const onPageChange = (page, rowsPerPage) => {
        context.setRoleInputFilter({
            ...context.getRoleInputFilter(),
            page:page,
            rowsPerPage: rowsPerPage
        })
        setPage(page)
        setRowsPerPage(rowsPerPage)
        getRoles(page)
    }

    const onFilter = (inputs) => {
        console.log(inputs,'inputs ee jadid')
        const params = makeParams(inputs).params
        setFilterNumber(makeParams(inputs).count)
        context.setRoleInputFilter({
            ...inputs,
            page:0
        })
        setPage(0)
        setParams(params)
    }

    useEffect( () => {
        getRoles(page)
    }, [params])


    return(

        <WithSidebar pageTitle={"Roles Management"} breadcrumb={"Dashboard > Roles"} listHeaders={<RolesHeader count={filterNumber} onFilter={ (inputs) => onFilter(inputs)}/>}>
            <List  columns={columns} type={'roles'} rows={data} totalCounts={totalCounts} page={page} rowsPerPage={rowsPerPage} onPageChange={ (page, rowsPerPage) => onPageChange(page, rowsPerPage)}/>
        </WithSidebar>
    )
}
export default Roles